import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'

import { AUTO_ATTR_KEY, AutomationId } from '../../../utils/automationUtil'

const Container = styled.div.attrs({ [AUTO_ATTR_KEY]: AutomationId.error.message })<{
  mode: Theme
}>`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${sys.typescale[14].size};
  color: ${({ mode }) => sys[mode].text.placeholder};
`

/*
 * This if for fixing the problem: Can't scroll to top of flex item that is overflowing container.
 * It centers the element based on the remaining margin.
 * Therefore, the overflowing content will be presented from the top instead of center since there's no remaining margins.
 */
const SafeCenter = styled.div`
  margin: auto;
`

interface ErrorMessageProps {
  children?: React.ReactNode
}

const ErrorMessage = ({ children }: ErrorMessageProps) => {
  const theme = useDisplayTheme()
  const { t } = useTranslation()

  return (
    <Container mode={theme}>
      <SafeCenter>
        {children ?? (
          <span aria-label="unexpected error" role="img">
            {t('unexpectedError')}
          </span>
        )}
      </SafeCenter>
    </Container>
  )
}

export default ErrorMessage
